/* Global Jquery */
import CSRFTokenResolver from "../global/CSRFTokenResolver";

global.jQuery = require('jquery');
window.jQuery = window.$ = jQuery;

// swiper bundle styles
import 'swiper/swiper-bundle.min.css'

// swiper core styles
import 'swiper/swiper.min.css'

// modules styles
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import Swiper, { Navigation, Pagination, Lazy, Thumbs, Controller } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy, Thumbs, Controller]);

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

import parsley from 'parsleyjs';

import LazyLoad from "vanilla-lazyload";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo"

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '2f56877bc7388f6893bf',
    cluster: 'eu',
    encrypted: true,
    namespace: 'Modules.Member.Events.LiveChat'
});

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': CSRFTokenResolver.getToken(),
    'X-Requested-With': 'XMLHttpRequest'
};

window.Echo.connector.pusher.connection.bind('connected', function () {
    window.axios.defaults.headers.common['X-Socket-ID'] = window.Echo.socketId();
});

(function() {

    var main = {
        init: function () {
            this.stickyNav();
            this.testimonials();
            this.instagram();
            this.gallery();
            this.micrositeVideo();
            this.inputs();
            this.navigation();
            this.tours();
            this.badges();
            this.twitter();
            this.chat();
            this.teamMembers();
            this.memberNavigation();
            this.alerts();
        },

        stickyNav: function() {
            const topHeaderNav = $('header#top-header');
            const accountNavigation = $('#account-navigation');
            let accountNavigationHeight;

            function updateAccountNavigationHeight() {
                if (accountNavigation.length > 0) {
                    return accountNavigation.height() || 40;
                }
                return false;
            }

            function toggleHeaderStickyState(offsetTop) {
                if ($(window).scrollTop() > 3) {
                    topHeaderNav.addClass('is-stuck');
                } else {
                    topHeaderNav.removeClass('is-stuck');
                }

                if (accountNavigation.length > 0) {
                    let offset = Math.round(offsetTop - $(window).scrollTop());
                    if (offset < 0) {
                        topHeaderNav.css('top', '0px');
                    } else {
                        topHeaderNav.css('top', offset + 'px');
                    }
                }
            }

            $(window).on('scroll', function() {
                toggleHeaderStickyState(accountNavigationHeight);
            });

            $(window).resize(function() {
                accountNavigationHeight = updateAccountNavigationHeight();
                toggleHeaderStickyState(accountNavigationHeight);
            });
            
            accountNavigationHeight = updateAccountNavigationHeight();
            toggleHeaderStickyState(accountNavigationHeight);

            let _pathname = window.location.pathname;

            if (_pathname) {
                if (_pathname.indexOf('booth') !== -1) {
                    $('body').addClass('account-nav__sticky');
                }
            }
        },

        testimonials: function() {
            if ($('.testimonials-slider .swiper-slide').length > 1) {
                new Swiper('.testimonials-slider', {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                    pagination: false,
                    preloadImages: false,
                    autoHeight: true,
                    lazy: true,
                    preloaderClass: '.lazy-preloader',
                    loadPrevNext: true,
                    loadPrevNextAmount: 4,
                    navigation: {
                        nextEl: '.testimonials-slider__next',
                        prevEl: '.testimonials-slider__prev'
                    }
                });
            } else {
                $('.testimonials-slider .slider-btn').removeClass('inline-flex');
                $('.testimonials-slider .slider-btn').addClass('hidden');
            }
        },
        
        instagram: function() {
            new Swiper('.instagram-slider', {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.instagram-slider__next',
                    prevEl: '.instagram-slider__prev'
                },
                pagination: false,
                preloadImages: false,
                lazy: true,
                loadPrevNext: true,
                loadPrevNextAmount: 4,
                breakpoints: {
                    480: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 20
                    },
                    720: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 40
                    }
                }
            });
        },

        gallery: function() {
            $('.g-slider').each((index, gallery) => {
                const id = $(gallery).data('id');

                if (id && id !== '') {
                    const galleryId = gallery.id || 'gallery-' + id;
                    const galleryThumbsId = 'gallery-thumbs-' + id;
                    const sliderBtnNext = $('#' + galleryId).parent().find('.slider-btn__next')[0];
                    const sliderBtnPrev = $('#' + galleryId).parent().find('.slider-btn__prev')[0];
                    let galleryThumbs, gallerySlider;

                    if (galleryId && galleryId !== '') {
                        galleryThumbs = new Swiper("#" + galleryThumbsId, {
                            spaceBetween: 12,
                            slidesPerView: 3,
                            preloadImages: false,
                            lazy: true,
                            centeredSlides: true,
                            slideToClickedSlide: true,
                            loadPrevNext: true,
                            loadPrevNextAmount: 2,
                            touchRatio: 0.2,
                            breakpoints: {
                                640: {
                                    slidesPerView: 4,
                                    spaceBetween: 20
                                },
                                720: {
                                    slidesPerView: 5,
                                    spaceBetween: 20
                                },
                                1024: {
                                    slidesPerView: 6,
                                    spaceBetween: 20
                                }
                            }
                        });
                    }
    
                    if (galleryThumbsId) {
                        gallerySlider = new Swiper("#" + galleryId, {
                            spaceBetween: 0,
                            preloadImages: false,
                            lazy: true,
                            navigation: {
                                nextEl: sliderBtnNext,
                                prevEl: sliderBtnPrev
                            }
                        });
                    }

                    gallerySlider.controller.control = galleryThumbs;
                    galleryThumbs.controller.control = gallerySlider;
                }
            });
        },

        micrositeVideo: function() {
            $('#play_video').on('click', (event) => {
                event.preventDefault();
                $('#microsite-video .iframe-wrapper').addClass('hidden');
                $('#microsite-video').addClass('visible');
                $('#microsite-video .loading-circle').removeClass('hidden');
                $('#microsite-video iframe').on('load', function(event) {
                    $('#microsite-video .loading-circle').addClass('hidden');
                    $('#microsite-video .iframe-wrapper').removeClass('hidden');
                });
                $('#microsite-video iframe').attr('src', $('#microsite-video iframe').data('src'));
            });
            
            $('#microsite-video').on('click', (event) => {
                event.preventDefault();
                $('#microsite-video').removeClass('visible');
                $('#microsite-video .iframe-wrapper').addClass('hidden');
                $('#microsite-video iframe').attr('src', '');
            });
            
            $('#microsite-video .iframe-wrapper').on('click', (event) => {
                event.stopPropagation();
            });
        },

        inputs: function() {
            /**
             * Source: https://stackoverflow.com/questions/2385701/regular-expression-for-first-and-last-name
             */
            let nameValidationRegex = /^[a-z ,.'-]+$/i;

            /**
             * Source: https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
             */
            let emailValidationRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
            
            /**
             * Source: https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
             */
            let telephoneValidationRegex = /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/;
            
            $('.input-field input, .input-field textarea').each((index, input) => {
                if ($(input).val() !== '' || $(input).val().length > 0) {
                    $(input).addClass('input-filled');
                }
            });

            $('.input-field input, .input-field textarea').on('focus', (event) => {
                let _input = $(event.target);
                if (_input.is(':required')) {
                    _input.attr('placeholder', '(Required)');
                }
            });

            $('.input-field input, .input-field textarea').on('blur change', (event) => {
                let _input = $(event.target);
                if (_input.val() !== '' || _input.val().length > 0) {
                    _input.addClass('input-filled');
                    
                    let valid = true;
                    if (_input.attr('id') === 'your_name') {
                        if (!nameValidationRegex.test(_input.val())) {
                            valid = false;
                            $('#' + _input.attr('id') + '-error').text('Invalid name');
                        }
                    } else if (_input.attr('id') === 'email_address') {
                        if (!emailValidationRegex.test(_input.val())) {
                            valid = false;
                            $('#' + _input.attr('id') + '-error').text('Please enter a valid email address');
                        }
                    } else if (_input.attr('id') === 'telephone') {
                        if (!telephoneValidationRegex.test(_input.val())) {
                            valid = false;
                            $('#' + _input.attr('id') + '-error').text('Please enter a valid telephone number');
                        }
                    }

                    if (valid) {
                        $('#' + _input.attr('id') + '-error').hide();
                    } else {
                        $('#' + _input.attr('id') + '-error').show();
                    }
                } else {
                    _input.removeClass('input-filled');

                    if (_input.is(':required')) {
                        $('#' + _input.attr('id') + '-error').text('This field is required');
                        $('#' + _input.attr('id') + '-error').show();
                    } else {
                        $('#' + _input.attr('id') + '-error').hide();
                    }
                }
                _input.attr('placeholder', '');
            });

            $('.input-field input, .input-field textarea').on('input', (event) => {
                if ($(event.target).val().length > 0) {
                    $('#' + $(event.target).attr('id') + '-error').hide();
                }
            });
        },

        navigation: function() {
            $('#open-menu').on('click', (event) => {
                event.preventDefault();
                $('#mobile-nav').addClass('visible');
                $('.background-overlay').addClass('visible');
            });
            
            $('#close-menu, .background-overlay').on('click', (event) => {
                event.preventDefault();
                $('#mobile-nav').removeClass('visible');
                $('.background-overlay').removeClass('visible');
            });
        },

        tours: function() {
            let _toursScrollElement = $('.tours-scroll');
            let _loadingEl = $('#tour-loading');

            $('#tour-player').on('load', (event) => {
                _loadingEl.hide();
                $('#tour-player').show();
            });

            function toggleArrows() {
                if (_toursScrollElement && _toursScrollElement.length) {
                    let _scrollWidth = _toursScrollElement.prop('scrollWidth');
                    let _elementWidth = _toursScrollElement.width();
                    let _scrollLeft = _toursScrollElement.scrollLeft();
    
                    if (_scrollWidth > _elementWidth) {
                        if (_scrollLeft > 5) {
                            $('.tours-btn__next').removeClass('hidden');
                        }
        
                        if ((_scrollLeft + _elementWidth + 5) > _scrollWidth) {
                            $('.tours-btn__next').removeClass('hidden');
                        }
                    }
                }
            }

            toggleArrows();

            window.onresize = function() {
                toggleArrows();
            };

            function showTour(item) {
                let _iframe = item.data('src');
                let _src;
                if (_iframe.indexOf('src') !== -1) {
                    let _attributes = _iframe.split(' ');
                    _attributes.forEach((attr) => {
                        if (attr.indexOf('src') !== -1) {
                            let _srcAttr;
                            if (attr.indexOf("'") !== -1) {
                                _srcAttr = attr.split("'");
                            } else {
                                _srcAttr = attr.split('"');
                            }
                            _src = _srcAttr[1];
                        }
                    });
                } else {
                    _src = _iframe.trim();
                }

                $('#tour-player').hide();
                $('#tour-player').attr('src', _src);
                _loadingEl.show();
                $('a.btn-tour__card').removeClass('selected');
                item.addClass('selected');
            }

            if ($('a.btn-tour__card') && $('a.btn-tour__card').length > 0) {
                $('a.btn-tour__card').first().addClass('selected');
                showTour($('a.btn-tour__card').first());
            }

            $('a.btn-tour__card').on('click', (event) => {
                event.preventDefault();
                showTour($(event.target));
            });
        },

        badges: function() {
            $('.badge-item').each((index, badge) => {
                const label = $(badge).data('label');

                tippy(badge, {
                    content: label
                });
            });

            const lazyLoad = new LazyLoad({
                use_native: true,
                unobserve_completed: true
            });
        },
        
        twitter: function() {
            new Swiper('.tweets-slider', {
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true,
                preloadImages: false,
                lazy: true,
                navigation: {
                    nextEl: '.tweets-slider__next',
                    prevEl: '.tweets-slider__prev'
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    }
                },
                pagination: {
                    el: ".tweets-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="pagination-item ' + className + '" role="button" tabindex="-1"></span>';
                    }
                }
            });
        },

        chat: function() {
            let chatInitialHeight = $('#chat').height();

            $(window).on('scroll', function() {
                let _offsetTop = $('footer').offset().top;
                let _viewportPosY = Math.round($(window).scrollTop() + $(window).height());
                let _enteredPosY = _viewportPosY - _offsetTop;
                
                if (!isNaN(_enteredPosY)) {
                    if (_enteredPosY >= 0) {
                        $('#join, #join-guest, #chat, #chat-message_bubble-wrap').css('bottom', (30 + _enteredPosY) + 'px');
                        $('#chat').css('max-height', (chatInitialHeight - _enteredPosY) + 'px');
                    } else {
                        $('#join, #join-guest, #chat, #chat-message_bubble-wrap').css('bottom', '30px');
                        $('#chat').css('max-height', chatInitialHeight + 'px');
                    }
                }
            });
        },

        teamMembers: function() {
            $('.member-email').each((index, badge) => {
                const label = $(badge).data('email');

                tippy(badge, {
                    content: label
                });
            });

            const lazyLoad = new LazyLoad({
                use_native: true,
                unobserve_completed: true
            });
        },

        memberNavigation: function() {
            $('.member-navigation--item').each((index, badge) => {
                const label = $(badge).attr('title');
                $(badge).data('title', label);

                tippy(badge, {
                    content: label,
                    distance: '12px'
                });
            });

            $('.member-navigation--item').removeAttr('title');
        },

        alerts: function() {
            $('.close-alert').on('click', (event) => {
                event.preventDefault();
                $(event.target).closest('.alert').hide();
            });
        }
    };

    main.init();

})();